import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import { ApiHelper } from '../../../utils/apiHelper';

export const updateMediaDocuments = createAsyncThunk(
    'media/updateMediaDocuments',
    async ({ startupId, showcasePhotoPath }) => {
        const payload = { startupId };
        
        if (showcasePhotoPath) {
            payload.showcasePhotoPath = showcasePhotoPath;
        }

        const response = await ApiHelper.put('/startup/media-documents', payload);
        return response.data;
    }
);

export const fetchMediaDocuments = createAsyncThunk(
    'media/fetchMediaDocuments',
    async (startupId) => {
        const response = await ApiHelper.get(`/startup/${startupId}/media-documents`);
        return response.data.startupMediaDocuments[0];
    }
);

export const createMedia = createAsyncThunk(
    'media/createMedia',
    async ({ startupId, mediaType, mediaPath }, { rejectWithValue }) => {
        try {
            const response = await ApiHelper.post('/startup/startup-media', {
                startupId,
                mediaType,
                mediaPath
            });

            toast.success('Medya başarıyla oluşturuldu');
            return response.data;
        } catch (error) {
            toast.error('Medya oluşturulurken hata oluştu');
            return rejectWithValue(error.message);
        }
    }
);

export const fetchMedia = createAsyncThunk('media/fetchMedia', async (startupId) => {
    const response = await ApiHelper.get(`startup/${startupId}/media`);
    return response.data.startupMedia;
});

const mediaSlice = createSlice({
    name: 'media',
    initialState: {
        mediaDocuments: null,
        mediaList: [],
        status: 'idle',
        error: null
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchMediaDocuments.pending, (state) => {
                state.loading = true;
            })
            .addCase(fetchMediaDocuments.fulfilled, (state, action) => {
                state.loading = false;
                state.mediaDocuments = action.payload;
            })
            .addCase(fetchMediaDocuments.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })
            .addCase(createMedia.fulfilled, (state, action) => {
                // Handle successful media creation if needed
            })
            .addCase(createMedia.rejected, (state, action) => {
                // Handle failed media creation if needed
            })
            .addCase(fetchMedia.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchMedia.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.mediaList = action.payload;
            })
            .addCase(fetchMedia.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            });
    }
});

export default mediaSlice.reducer;